<template>
  <div class="container-payments" v-if="payment_data.payments.length > 0">
    <h5 class="text-center text-bold">
      CONTRATO Nº
      {{ new Intl.NumberFormat("es-CL").format(payment_data.contract_number) }}
    </h5>
    <br />
    <b-overlay :show="loading" rounded="lg" spinner-variant="gold">
      <b-row style="width: 100%;" class="content-card">
        <b-col>
          <b-table-simple condensed borderless hover>
            <tbody>
              <b-tr class="d-none d-lg-table-row">
                <b-th>Descripción</b-th>
                <b-th>Monto Pactado</b-th>
                <b-th>Fecha Pactada</b-th>
                <b-th>Estado</b-th>
                <b-th>Acción</b-th>
              </b-tr>
              <template v-for="(payment, key) in pageOfItems">
                <b-tr :key="'pay-tr' + key" class="d-none d-lg-table-row">
                  <b-td>
                    {{ payment.descripcionPago }}
                  </b-td>
                  <b-td>
                    {{
                      new Intl.NumberFormat("es-CL").format(
                        (Math.round(payment.montoPago * 100) / 100).toFixed(2),
                      )
                    }}
                    UF
                  </b-td>
                  <b-td>
                    {{ formatDate(payment.fechaVencimientoPago) }}
                  </b-td>
                  <b-td>
                    <h5>
                      <b-badge v-if="is_payed(payment)" variant="success"
                        >Pagado</b-badge
                      >
                      <!-- <b-badge v-else-if="active_oneclick(payment)" variant="secondary">Programado</b-badge> -->
                      <b-badge v-else variant="secondary">Sin Pagar</b-badge>
                    </h5>
                  </b-td>
                  <b-td>
                    <b-button
                      block
                      v-if="is_payed(payment)"
                      squared
                      variant="outline-gold"
                      class="my-2 my-sm-0"
                      type="button"
                      :href="payment.urlReport"
                      target="_blank"
                      >Recibo</b-button
                    >
                    <b-button
                      block
                      v-else
                      squared
                      @click="showModal(payment)"
                      variant="gold"
                      class="my-2 my-sm-0"
                      type="button"
                      :href="payment.urlReport"
                      :disabled="payment.montoPago == 0 ? true : false"
                      >Pagar</b-button
                    >
                  </b-td>
                </b-tr>
                <b-tr :key="'small-pay-tr' + key" class="d-lg-none">
                  <b-td>
                    <b>{{ payment.descripcionPago }}</b> <br />
                    {{
                      new Intl.NumberFormat("es-CL").format(
                        (Math.round(payment.montoPago * 100) / 100).toFixed(2),
                      )
                    }}
                    UF <br />
                    <small>
                      {{ formatDate(payment.fechaVencimientoPago) }}</small
                    >
                    <h5>
                      <b-badge v-if="is_payed(payment)" variant="success"
                        >Pagado</b-badge
                      >
                      <b-badge v-else variant="secondary">Sin Pagar</b-badge>
                    </h5>
                  </b-td>
                  <b-td class="align-middle text-right">
                    <b-button
                      block
                      v-if="is_payed(payment)"
                      squared
                      variant="outline-gold"
                      class="my-2 my-sm-0"
                      type="button"
                      :href="payment.urlReport"
                      target="_blank"
                      >Recibo</b-button
                    >
                    <b-button
                      block
                      v-else
                      squared
                      @click="showModal(payment)"
                      variant="gold"
                      class="my-2 my-sm-0"
                      type="button"
                      :href="payment.urlReport"
                      :disabled="payment.montoPago == 0 ? true : false"
                      >Pagar</b-button
                    >
                  </b-td>
                </b-tr>
              </template>
            </tbody>
          </b-table-simple>
        </b-col>
      </b-row>
      <div class="text-right">
        <jw-pagination
          :pageSize="10"
          :items="payment_data.payments"
          @changePage="onChangePage"
          :styles="customStyles"
          :labels="customLabels"
        ></jw-pagination>
      </div>
      <b-modal
        ref="my-modal"
        hide-footer
        :title="'Pago de Cuota ' + transbank.id"
      >
        <b-overlay
          :show="transbank.loading"
          rounded="lg"
          spinner-variant="gold"
        >
          <div class="d-block" v-if="false">
            <p>
              Dada la Próxima entrega de Edificio connection, si desea realizar
              un pago, contactarse con su ejecutiva <b>Consuelo acuña</b>.
            </p>
            <b>Celular:</b>
            <a href="tel:569971384179" class="text-danger">+569 9 7138 4179</a>
            <br />
            <b>Email:</b>
            <a href="mailto:cacuna@bravoizquierdo.cl" class="text-danger"
              >cacuna@bravoizquierdo.cl
            </a>
          </div>
          <div class="d-block text-center" v-else>
            <h3>
              <small>Monto: </small>$
              {{ new Intl.NumberFormat("es-CL").format(transbank.monto) }}
            </h3>
            <form
              id="webpay-form"
              ref="form"
              action="https://webpay3g.transbank.cl:443/webpayserver/initTransaction"
              accept-charset="UTF-8"
              method="post"
            >
              <input
                id="webpay-token"
                type="hidden"
                name="token_ws"
                v-model="transbank.token"
              />
            </form>
            <b-button
              class="mt-2"
              variant="outline-success"
              block
              @click="webpay_payment"
              >Pagar</b-button
            >
          </div>
        </b-overlay>
      </b-modal>
    </b-overlay>
  </div>
</template>
<script>
export default {
  name: "payments",
  components: {},
  props: {
    asset_id: { default: null },
    project_id: { default: null },
  },
  data() {
    return {
      showPayment: true,
      customStyles: {
        li: {
          display: "inline-block",
        },
        a: {
          color: "black",
        },
      },
      customLabels: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
      transbank: {
        token: "",
        url: "",
        monto: "",
        concept: "",
        back_url: window.location.href,
        id: "",
        loading: false,
      },
      pageOfItems: [],
      Apartment: null,
      loading: true,
      payment_data: {
        contract_number: "",
        payments: [],
        loading: null,
      },
    };
  },
  mounted() {
    let self = this;
    this.axios.get("payments/").then((result) => {
      result.data.map(function(value) {
        self.loading = false;
        value.bienes.map(function(v) {
          if (self.asset_id == v.id) {
            self.payment_data.contract_number = value.id;
            self.Apartment = v;
            self.payment_data.payments = value.pagos;
            self.payment_data.loading = false;
            self.$store.commit("setContractId", value.id);
          }
        });
      });
    });
  },
  computed: {
    have_cards() {
      console.log("test");
      console.log(this.$store.getters.getCards);
      return this.$store.getters.getCards != undefined;
    },
  },
  methods: {
    formatDate(date) {
      const dateStr = this.gcVersion == 1 ? date : date.toString().slice(0, 10);
      return this.$moment(dateStr).format("DD-MM-YYYY");
    },
    active_oneclick(payment) {
      if (payment) {
        return this.have_cards;
      } else {
        return false;
      }
    },
    webpay_payment() {
      this.transbank.loading = true;
      this.axios
        .post("payments/webpay", { transbank: this.transbank })
        .then((result) => {
          this.transbank.token = result.data.token;
          this.transbank.url = result.data.url;
          this.transbank.loading = false;
          if (this.transbank.token)
            document.getElementById("webpay-token").value = result.data.token;
          document.getElementById("webpay-form").submit();
        })
        .catch(() => {
          this.transbank.loading = false;
        });
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    showModal(payment) {
      this.$refs["my-modal"].show();
      this.transbank.id = payment.codigo;
      this.transbank.monto = parseInt(payment.montoPago * payment.valorUF);
    },
    is_payed(payment) {
      if (payment.reciboPago === undefined) {
        return false;
      } else {
        return payment.reciboPago.length > 0;
      }
    },
  },
};
</script>
<style></style>
